var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { GetDoc, GetDocs, IsAuthValid, StoreAccessor } from "mobx-firelink";
import { GetAuth } from "Store/firebase";
import { O } from "vwebapp-framework";
export class UsersState {
}
__decorate([
    O
], UsersState.prototype, "subpage", void 0);
__decorate([
    O
], UsersState.prototype, "selectedUserID", void 0);
export const GetSelectedUserID = StoreAccessor("GetSelectedUserID", s => () => {
    return s.main.users.selectedUserID;
});
export const GetSelectedUser = StoreAccessor("GetSelectedUser", s => () => {
    const selectedID = GetSelectedUserID();
    return (GetUsers() || []).find(a => a && a._key == selectedID);
});
/* export function GetAuth(state: RootState) {
    return state.firebase.auth;
} */
export const MeID = StoreAccessor("MeID", s => () => {
    // return state.firebase.data.auth ? state.firebase.data.auth.uid : null;
    // return GetData(state.firebase, "auth");
    /* var result = helpers.pathToJS(firebase, "auth").uid;
    return result; */
    /* let firebaseSet = State().firebase as Set<any>;
    return firebaseSet.toJS().auth.uid; */
    // return State("firebase", "auth") ? State("firebase", "auth", "uid") : null;
    return IsAuthValid(GetAuth()) ? GetAuth().id : null;
});
export const Me = StoreAccessor("Me", s => () => {
    return GetUser(MeID());
});
export const GetUser = StoreAccessor("GetUser", s => (userID) => {
    return GetDoc({}, a => a.users.get(userID));
});
export const GetUsers = StoreAccessor("GetUsers", s => () => {
    return GetDocs({}, a => a.users);
});
/* export type UserExtraInfoMap = { [key: string]: UserExtraInfo };
export const GetUserExtraInfoMap = StoreAccessor("GetUserExtraInfoMap", (s) => (): UserExtraInfoMap => {
    return GetDocs((a) => a.userExtras);
}); */
export const GetUserExtraInfo = StoreAccessor("GetUserExtraInfo", s => (userID) => {
    return GetDoc({}, a => a.userExtras.get(userID));
});
export const GetUserJoinDate = StoreAccessor("GetUserJoinDate", s => (userID) => {
    return GetDoc({}, a => a.userExtras.get(userID))?.joinDate;
});
const defaultPermissions = { basic: true, verified: true, mod: false, admin: false }; // temp
export const GetUserPermissionGroups = StoreAccessor("GetUserPermissionGroups", s => (userID) => {
    if (userID == null)
        return null;
    return GetDoc({}, a => a.userExtras.get(userID))?.permissionGroups ?? defaultPermissions;
});
/*export function GetUserAccessLevel(userID: string) {
    const groups = GetUserPermissionGroups(userID);
    if (groups == null) return AccessLevel.Basic;

    if (groups.admin) return AccessLevel.Admin;
    if (groups.mod) return AccessLevel.Mod;
    if (groups.verified) return AccessLevel.Verified;
    // if (groups.basic) return AccessLevel.Basic;
    Assert(false);
}*/
export function GetUserBackground(userID) {
    return {
        url_max: "/Images/Backgrounds/Planet_x3840.jpg",
        url_1920: "/Images/Backgrounds/Planet_x1920.jpg",
        url_3840: "/Images/Backgrounds/Planet_x3840.jpg",
    };
    /*const user = GetUser(userID);
    if (!user) return presetBackgrounds[defaultPresetBackground];

    if (user.backgroundCustom_enabled) {
        return {
            color: user.backgroundCustom_color,
            url_1920: user.backgroundCustom_url,
            url_3840: user.backgroundCustom_url,
            url_max: user.backgroundCustom_url,
            position: user.backgroundCustom_position || "center center",
        };
    }

    const background = presetBackgrounds[user.backgroundID] || presetBackgrounds[defaultPresetBackground];
    return background;*/
}
